import { render, staticRenderFns } from "./IncompleteVisits.vue?vue&type=template&id=4b0036e6"
import script from "./IncompleteVisits.vue?vue&type=script&lang=ts"
export * from "./IncompleteVisits.vue?vue&type=script&lang=ts"
import style0 from "./IncompleteVisits.vue?vue&type=style&index=0&id=4b0036e6&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports